import { IPayerEngagementResponse } from "@wingspanhq/payments/dist/interfaces";
import { IPayeeEngagementResponse } from "@wingspanhq/payments/dist/interfaces/api/payerPayeeEngagement";
import { RequirementTableItemData } from "../types";

export const selectorRequirementsFromEngagement = (
  engagement: IPayeeEngagementResponse | IPayerEngagementResponse
): RequirementTableItemData[] => {
  const allRequirements = engagement.requirements;

  const extendedRequirements = allRequirements.map(req => ({
    ...req,
    engagementId: engagement.payerPayeeEngagementId,
    relatedEngagementRequirementIds: [
      {
        engagementId: engagement.payerPayeeEngagementId,
        relatedRequirementId: req.requirementId
      }
    ]
  }));

  return extendedRequirements;
};
